export function loginFcmFum(loginFcm,fcmStatus,age) {
    var status = "0"; //需要实名认证
    if( loginFcm==1){
        if( fcmStatus != "0"){
            if(age!=null && age!='' && age!=undefined){
                if(age >=18){
                    status= "1"; //无需判断
                }else{
                    status= "2"; //未成年
                }
            }
        }else{
            status= "0";//需要实名认证
        }
    }else{
        status= "1";//无需判断
    }
    return status;
}



// WEBPACK FOOTER //
// ./src/common/js/fcm.js